module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('navbar', [_c('button', {
    staticClass: "navbar-toggler mobile-sidebar-toggler d-lg-none",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.mobileSidebarToggle
    }
  }, [_vm._v("\n        ☰\n    ")]), _vm._v(" "), _c('a', {
    staticClass: "navbar-brand"
  }), _vm._v(" "), _c('ul', {
    staticClass: "nav navbar-nav d-md-down-none"
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link navbar-toggler sidebar-toggler",
    on: {
      "click": _vm.sidebarMinimize
    }
  }, [_vm._v("☰")])])]), _vm._v(" "), _c('Dropdown', [_c('Button', {
    attrs: {
      "size": "large",
      "icon": "md-globe",
      "type": "primary",
      "id": "langbtn"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('switchLanguages')) + "\n        ")]), _vm._v(" "), _c('DropdownMenu', {
    attrs: {
      "slot": "list"
    },
    slot: "list",
    model: {
      value: (_vm.locale),
      callback: function($$v) {
        _vm.locale = $$v
      },
      expression: "locale"
    }
  }, _vm._l((_vm.changeLang), function(item, index) {
    return _c('DropdownItem', {
      key: index,
      attrs: {
        "value": item.value
      },
      nativeOn: {
        "click": function($event) {
          return _vm.changeLangFn(item.value)
        }
      }
    }, [_vm._v("\n                " + _vm._s(item.label) + "\n            ")])
  }), 1)], 1), _vm._v(" "), _c('ul', {
    staticClass: "nav navbar-nav ml-auto"
  }, [_c('div', {
    staticStyle: {
      "float": "right",
      "display": "block",
      "margin-right": "50px"
    }
  }, [_c('i-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.contact
    }
  }, [_vm._v(_vm._s(_vm.$t('contact')))])], 1), _vm._v(" "), _c('Dropdown', {
    staticClass: "nav-item"
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    }
  }, [_c('span', {
    attrs: {
      "slot": "button"
    },
    slot: "button"
  }, [_c('img', {
    staticClass: "img-avatar",
    attrs: {
      "src": "static/img/avatars/6.jpg",
      "alt": "o"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "d-md-down-none"
  }, [_vm._v(_vm._s(_vm.account))])])]), _vm._v(" "), _c('Dropdown-menu', {
    attrs: {
      "slot": "list"
    },
    slot: "list"
  }, [_c('Dropdown-item', [_c('p', {
    staticClass: "dropdown-itemp",
    on: {
      "click": _vm.perDetails
    }
  }, [_c('Icon', {
    attrs: {
      "type": "android-contact"
    }
  }), _vm._v("\n                        " + _vm._s(_vm.$t('personalInformation')) + "\n                    ")], 1)]), _vm._v(" "), _c('Dropdown-item', [_c('p', {
    staticClass: "dropdown-itemp",
    on: {
      "click": _vm.ChangePassword
    }
  }, [_c('Icon', {
    attrs: {
      "type": "android-settings"
    }
  }), _vm._v("\n                        " + _vm._s(_vm.$t('agent.editPassword')) + "\n                    ")], 1)]), _vm._v(" "), _c('Dropdown-item', [_c('a', {
    attrs: {
      "href": ""
    },
    on: {
      "click": _vm.Logout
    }
  }, [_c('p', {
    staticClass: "dropdown-itemp"
  }, [_c('Icon', {
    attrs: {
      "type": "power"
    }
  }), _vm._v("\n                        " + _vm._s(_vm.$t('logout')) + "\n                    ")], 1)])])], 1)], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item d-md-down-none"
  })], 1), _vm._v(" "), _c('perDetails', {
    attrs: {
      "details": _vm.details
    },
    on: {
      "closeWin": _vm.closeWin
    }
  }), _vm._v(" "), _c('ChangePassword', {
    attrs: {
      "Form": _vm.Form
    },
    on: {
      "closePasswordForm": _vm.closePasswordForm
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-43c3657a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Header.vue
// module id = 473
// module chunks = 103